import { Component, ViewChild } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-copy-data-renderer',
  templateUrl: './copy-data-renderer.component.html',
  styleUrls: ['./copy-data-renderer.component.scss']
})
export class CopyDataRendererComponent implements ICellRendererAngularComp {
  public params: any;
  public isCopying: boolean = false;
  public delay: number = 1_000;

  @ViewChild('tooltip', { read: MatTooltip }) tooltip: MatTooltip;

  agInit(params: any): void {
    this.params = params;
  }

  refresh(params: ICellRendererParams<any, any>): boolean {
    return false;
  }

  // other parts of the component

  copyDataToClipboard() {
    this.isCopying = true;
    navigator.clipboard.writeText(this.params.value);
    this.tooltip.hideDelay = (this.delay - 400);
    this.tooltip.show();
    this.tooltip.hide();
    setTimeout(() => {
      this.tooltip.hideDelay = 0;
      this.isCopying = false;
    }, this.delay);
  }
}
